/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-07-28 17:32:12
 */
import React from 'react'

export default [
  {
    title: '拍摄人',
    dataIndex: 'userNickname',
    width: 140
  },
  {
    title: '水印名称',
    dataIndex: 'watermarkName',
    width: 150,
    render: (text, record) => {
      if (!text) {
        return (
          <div style={{ textAlign: 'center', color: '#c9c9c9' }}>
            <p>未使用团队水印</p>
            <p>无法显示水印名称</p>
          </div>
        )
      } else {
        return text
      }
    }
  },
  {
    title: '审核结果',
    dataIndex: 'reviewResult',
    key: 'reviewResult',
    width: 150,
    render: (text, record) => {
      // 判断是否存在审核信息
      if (!record.neteaseShelfReview || !record.neteaseShelfReview.exist) {
        return <span>未设置ai审核规范</span>
      }

      // 根据reviewResult展示不同状态
      const { reviewResult } = record.neteaseShelfReview
      if (reviewResult === -1) {
        return <span>AI审核中</span>
      }
      if (reviewResult === 0) {
        return <span>不合格</span>
      }
      if (reviewResult === 1) {
        return <span>合格</span>
      }

      // 其他情况（包括reviewResult === 2）
      return <span>不计入</span>
    }
  },
  {
    title: '审核人',
    dataIndex: 'reviewOperator',
    key: 'reviewOperator',
    width: 180,
    render: (text, record) => {
      // 判断是否存在审核信息
      if (!record.neteaseShelfReview || !record.neteaseShelfReview.exist) {
        return <span>未设置ai审核规范</span>
      }

      // 如果是AI审核中
      const { reviewResult, reviewType, operator } = record.neteaseShelfReview
      if (reviewResult === -1) {
        return <span>AI审核中</span>
      }

      // 如果是AI审核
      if (reviewType === 1) {
        return <span>AI审核</span>
      }

      // 其他情况返回操作人昵称
      return <span>{operator?.nickname || '-'}</span>
    }
  },
  {
    title: '拍摄时间',
    dataIndex: 'time',
    width: 180
  },
  {
    title: '拍摄地点',
    dataIndex: 'addr',
    width: 180
  },
  {
    title: '天气',
    dataIndex: 'weather',
    width: 140
  },
  {
    title: '经度',
    dataIndex: 'lng',
    width: 140
  },
  {
    title: '纬度',
    dataIndex: 'lat',
    width: 140
  },
  {
    title: '坐标系',
    dataIndex: 'coordinates',
    width: 140
  },
  {
    title: '海拔',
    dataIndex: 'altitude',
    width: 140
  },
  {
    title: '得分',
    key: 'score',
    dataIndex: 'score',
    width: 115,
    render: (text) => {
      return <div>{String(text) ? text : '-'}</div>
    }
  },
  {
    title: '打分人',
    key: 'scorerName',
    dataIndex: 'scorerName',
    width: 115,
    render: (text) => {
      return <div>{text ? text : '-'}</div>
    }
  },
  {
    title: '评论',
    dataIndex: 'extension.comments',
    width: 200
  }
]

export const customerColumns = [
  {
    title: '客户名称',
    dataIndex: 'customer.customerName',
    width: 115
  },
  {
    title: '客户地址',
    dataIndex: 'customer.customerAddress',
    width: 115
  },
  {
    title: '客户联系人',
    dataIndex: 'customer.customerContractName',
    width: 115
  },
  {
    title: '客户电话',
    dataIndex: 'customer.customerTel',
    width: 115
  }
]
